const firebaseConfig = {
  apiKey: "AIzaSyD-czdmWW0zmWS8YQ5-pKfjKBeHw9LGKww",
  authDomain: "turbo-dynamics-pro.firebaseapp.com",
  projectId: "turbo-dynamics-pro",
  storageBucket: "turbo-dynamics-pro.appspot.com",
  messagingSenderId: "472959875726",
  appId: "1:472959875726:web:b3ba56785e0235f4f667df"
};
export default firebaseConfig;